import { useState } from 'react';
import Button from '@mui/material/Button';
import ApprovalDialogBox from './ApprovalDialogBox';
import RejectUserDialog from './RejectUserDialog';
import DataTable from '../datatable/datatable';
import { DateTime } from 'luxon';

const PendingInvites = ({ rows, setRows, isDataLoading, setIsDataLoading }) => {
    const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState([])

    const columns = [
        {
            header: "Action",
            width: "180px",
            cell: ({ row }) => (
                <div className='buttonContainer_signupRequest'>
                    <Button variant='contained' className='button_signupRequest' color="success" onClick={() => handleApprove(row.original)}>Approve</Button>
                    <Button variant='contained' className='button_signupRequest' color='error' onClick={() => handleReject(row.original)}>Reject</Button>
                </div>
            )
        },
        {
            accessorKey: "name",
            header: "Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: "email",
            header: "Email",
            width: "270px",
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: "orgName",
            header: "Organization",
            width: "150px",
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: "countryName",
            header: "Country",
            width: "150px",
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: "contactNo",
            header: "Contact Number",
            width: "200px",
            enableSorting: true,
            enableFiltering: true,
        },
        {
            header: "Request Date",
            width: "150px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ row }) => (
                (() => {

                    const raw = row.original.createdAt || row.original.createdAt;
                    if (!raw) return "";
                    const iso = DateTime.fromISO(raw);
                    if (iso.isValid) return iso.toFormat("dd-MMM-yyyy");
                    const jsDate = new Date(raw);
                    if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("dd-MMM-yyyy");
                    return String(raw);
                }))()
        },
    ]



    const handleApprove = (row) => {
        setSelectedUserData(row)
        setOpenApprovalDialog(true);
    };

    const handleReject = (row) => {
        setSelectedUserData(row)
        setOpenRejectDialog(true);
    };

    const pendingRowAdjustment = (data) => {
        let allPendingUsers = [...rows];
        allPendingUsers = allPendingUsers.filter((user) => user._id !== data._id);
        setRows(allPendingUsers);
        setIsDataLoading(false);
    }

    return (
        <>
            <DataTable
                data={rows}
                columns={columns}
                isLoading={isDataLoading}
                enableFiltering={true}
                enablePagination={true}
                enableSorting={false}
                pageSizeOptions={[10, 20, 50, 100]}
                noDataText="No results found !"
            />
            <ApprovalDialogBox
                open={openApprovalDialog}
                handleClose={() => setOpenApprovalDialog(false)}
                isEdit={false}
                userData={selectedUserData}
                pendingRowAdjustment={pendingRowAdjustment}
                setKendoDataLoading={setIsDataLoading}
            />
            <RejectUserDialog
                open={openRejectDialog}
                onClose={() => setOpenRejectDialog(false)}
                userData={selectedUserData}
                pendingRowAdjustment={pendingRowAdjustment}
                setKendoDataLoading={setIsDataLoading}
            />
        </>
    );
};

export default PendingInvites;